/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { setInsights, resetInsightsObj } from "../../store/insights/actions";

const InsightsComponent = ({ payload }) => {
  const dispatch = useDispatch();

  const features = useSelector((state) => state?.Login?.data?.features);
  const insights = useSelector((state) => state?.Insights);

  const isFeatureInsightActive = features?.find((e) => e.name === "Insight")
    ?.active;
  const regexList = features
    ?.find((e) => e.name === "Insight") //**ATENTION: if backend change feature name this will no longer work*/
    ?.config?.list?.map(
      (e) => e.active && { id: e.id, name: e.name, regex: e.regex }
    );

  const testRegex = (message) => {
    let result = null;
    regexList.forEach((element) => {
      try {
        const str = element.regex;
        const expReg = new RegExp(
          str.match("(?<=/)(.*)(?=/)")[0], //This get all between two "/" (regex)
          str.substr(str.lastIndexOf("/") + 1, str.lenght) //This get all after last "/" (flags)
        );
        result = {
          id: element.id,
          name: element.name,
          value: message.match(expReg)[0], //If it doesn't match it will cause an error here and will fall into the catch so result will remain equal to null
        };
      } catch (error) {
        //Invalid Expression or Message Not Match
      }
    });
    return result;
  };

  const getInsights = (data) => {
    try {
      data?.message.forEach((element) => {
        if (regexList) {
          const insight = testRegex(element?.text);
          if (insight) {
            const newFields = {
              conversation_id: data?.conversationId,
              message_current_id: element?.currentId,
              insight_id: insight?.id,
              name: insight?.name,
              text: insight?.value,
            };
            dispatch(setInsights(newFields));
          }
        }
      });
    } catch (error) {}
  };

  useEffect(() => {
    if (payload && isFeatureInsightActive) {
      getInsights(payload);
    }
  }, [payload]);

  useEffect(() => {
    if (insights?.status?.set_insights?.success) {
      dispatch(resetInsightsObj());
    }
  }, [insights]);

  return <></>;
};

export default InsightsComponent;
